import { apolloService } from 'app/services';
import { PATCH_ENROLLMENT_MUTATION } from '../../mutations/PATCH_ENROLLMENT_MUTATION';

/**
 * Triggers the submission of a rating for a specific course specified by ID.
 * 
 * @param { string } courseId - The ID of the course to submit the rating for.
 * @param { number } rating - The rating to give the course [0-5].
 * @param { string } [review] - The review or comments to add onto the rating (optional).
 */
export const submitCourseRating = async ( courseId, rating, review = undefined ) => {
    // Determine if the data provided is valid for the submission.
    const validData = Boolean( courseId );

    if ( validData ) {
        // Make sure the rating value is valid.
        rating = Math.min( Math.max( rating, 0 ), 5 );

        // Send the mutation to update the user's enrollment data (which holds the user's ratings).
        try {
            await apolloService.mutate( {
                variables: { 
                    input: { courseID: courseId, rating, review },
                },
                fetchPolicy: 'no-cache',
                mutation: PATCH_ENROLLMENT_MUTATION,
            } );

            return true;
        }
        catch ( error ) {
            return false;
        }
    } else {
        console.warn( `Rating submission for course '${ courseId }' has failed with the following input:`, { rating, review } );
        return false;
    }
};
